export default {
    'invoice-no': 'Número de factura',
    new: 'Nuevo',
    delete: 'Eliminar',
    account: 'Cuenta',
    'invoice-date': 'Fecha de factura',
    warehouse: 'Almacén',
    document: 'Ref. Doc.',
    'net-invoice': 'Gran cantidad',
    save: 'Guardar',
    edit: 'Editar',
    not: 'No',
    posted: 'Publicado',
    'add-invoice': 'Añadir factura',
    create: 'Crear',
    cancel: 'Cancelar',

    'delete-entry': 'Eliminar artículo',
    'are-you-sure-you-want-to-delete-the-entry': '¿Estás seguro de que quieres eliminar este artículo?',
    
    'delete-invoice': 'Eliminar factura',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': '¿Está seguro de eliminar la factura, el bono asociado también se eliminará?',
    notes: 'Notas',
    discount: 'Descuento',
    total: 'Total',

    headers: {
        no: 'Número',
        warehouse: 'Almacén',
        material: 'Artículo',
        quantity: 'Cantidad',
        count: 'Conteo',
        price: 'Precio',
        'discount-percentage': 'Porcentaje de descuento',
        'discount': 'Descuento',
        'after-discount': 'Valor neto',
        'notes': 'Notas',
    },

    'context-menu': {
        edit: 'Editar',
        delete: 'Eliminar'
    },
    receivables: 'Cuentas por cobrar',
    'total-receipts': 'Recibos totales',
    'alert-message': 'Mensaje de alerta',
    'confirm-message': 'Los ingresos totales se han vuelto mayores que el total. ¿Quieres continuar?'
}